import { SEARCH_WINDOW_OPEN } from '../Actions/SearchWindow.action';

const DEFAULT_STATE = { 
    open: false
};

export const searchWindow = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SEARCH_WINDOW_OPEN:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}